'use strict';

const commonParser = require('../../modules/parsers/dynpack_common');
const trackingUtils = require('../../modules/utils/tracking.utils');
const HIGH_SCORE_VALUE = 3;
const xsellUtils = require('../../modules/utils/xsell.utils.js');

function getSelectedSortingText(value) {
    switch (value) {
        case 'BEST_SELLING':
            return 'popular';
        case 'BEST_PRICE_DESC':
            return 'price';
        default:
            return 'recommended';
    }
}

function getDiscountTrackingLabel(discount) {
    const trackingLabels = {
        discountLevel1: 'gdeal',
        discountLevel2: 'deal',
        discountLevel3: 'nodeal',
    };
    return commonParser.getDiscountLevel(discount, trackingLabels);
}

function getHighlightedType(bestDeal, goodValueForMoney) {
    let label = 'NA';
    if (bestDeal) {
        label = 'match';
    } else if (goodValueForMoney) {
        label = 'deal';
    }
    return label;
}

function getCheckInDate(searchParams) {
    let checkIn;

    if (xsellUtils.isTelesalesMarketingPortal()) {
        checkIn = Odigeo.Utils.parseJson(Odigeo.Session.get('intPageAccommodationResults')).accommodationCheckInDate;
    } else {
        checkIn = searchParams.checkInDate ? searchParams.checkInDate : searchParams.searchSegments[0].dateStr;
    }
    return Odigeo.Utils.parseDate(checkIn);
}

function getCheckOutDate(searchParams) {
    let checkOut;

    if (xsellUtils.isTelesalesMarketingPortal()) {
        checkOut = Odigeo.Utils.parseJson(Odigeo.Session.get('intPageAccommodationResults')).accommodationCheckOutDate;
    } else if (searchParams.checkOutDate) {
        checkOut = searchParams.checkOutDate;
    } else if (xsellUtils.canImprovePricePerception(searchParams)) {
        const {departureDate} = xsellUtils.getItineraryDatesFromSearchParams(searchParams);
        checkOut = xsellUtils.getPricePerceptionCheckoutDateStr(departureDate);
    } else {
        checkOut = searchParams.searchSegments[1].dateStr;
    }
    return Odigeo.Utils.parseDate(checkOut);
}

function retrieveNumberOfNights(searchParams) {
    const checkInDate = getCheckInDate(searchParams);
    const checkOutDate = getCheckOutDate(searchParams);

    return Odigeo.Utils.getDifferenceInDays(checkInDate.getTime(), checkOutDate.getTime());
}

function calculateNights(searchParams) {
    let nights;
    const isOneWay = searchParams.type === 'oneWayTrip';
    if (Odigeo.AB.isIntermediatePageForOwDesktop && Odigeo._.isUndefined(searchParams.checkInDate) && isOneWay) {
        nights = xsellUtils.isTelesalesMarketingPortal() ? retrieveNumberOfNights(searchParams) : 1;
    } else {
        nights = retrieveNumberOfNights(searchParams);
    }
    return nights;
}

function getPriceInfo(result) {
    const {upsellPriceBreakdown} = result;

    return upsellPriceBreakdown
        ? {
            pricePerPassenger: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.pricePerPassenger),
            pricePerPassengerWithoutDiscount: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.pricePerPassengerWithoutDiscount),
            packageDiscountAmountPerPassenger: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.packageDiscountAmountPerPassenger),
            primeDiscountAmountPerPassenger: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.primeDiscountAmountPerPassenger),
            discountPercentage: upsellPriceBreakdown.discountPercentage,
        }
        : {};
}

function getHotelLocationData(accommodationDeal, accommodationInfo) {
    const {coordinates, distance, address, city} = accommodationInfo;
    const {key, tripAdvisorId} = accommodationDeal;
    const hasToggleMapDetails = !Odigeo._.isEmpty(coordinates);
    return {
        toggleMapDetailsClass: hasToggleMapDetails ? 'odf-clickable accommodation_toggle_details' : '',
        hotelKey: key,
        hasToggleMapDetails,
        distance,
        address,
        coordinates,
        tripAdvisorId,
        city,
    };
}

function getPeople(searchParams) {
    const {numAdults, numChildren, numInfants} = searchParams;
    return numAdults + numChildren + numInfants;
}

function getResultData(model, widget) {
    const {result, index} = widget;
    const {accommodationDeal, accommodationInfo, bestDeal, isPrimeDays} = result;
    const {key, boardType} = accommodationDeal;
    const hasBoardType = commonParser.isValidHotelData(boardType);
    const searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
    const nights = calculateNights(searchParams);
    const people = getPeople(searchParams);
    const isAccommodationPostBooking = Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
    const flightSelectionDTO = isAccommodationPostBooking ? null : model.get('flightSelectionDTO');
    const priceWithoutDiscountSelected = flightSelectionDTO ? flightSelectionDTO.fareItinerary.priceWithoutDiscountSelected : null;
    const isPrimeSelected = priceWithoutDiscountSelected === null ? false : Odigeo.AB.isPrimeEnabled && !priceWithoutDiscountSelected;

    return Odigeo._.extend({}, model.toJSON(), result, {
        category: commonParser.getHotelCategory(accommodationInfo.category) || {},
        boardTypeIcon: hasBoardType && commonParser.getBoardTypeIcon(boardType),
        searchId: flightSelectionDTO ? flightSelectionDTO.searchId : null,
        nightsText: commonParser.getTextPriceTotal(people, nights, isPrimeSelected),
        isTopChoice: commonParser.isTopChoice(result, widget),
        hotelLocation: getHotelLocationData(accommodationDeal, accommodationInfo),
        hotelBackgroundImage: commonParser.getBackgroundImageError(accommodationInfo.imgUrl, model.get('noHotelPic')),
        accommodationTypeTranslate: Odigeo.Utils.capitalize(
            Odigeo.UIElements.translations.dynpackProduct.accommodationTypes[accommodationInfo.type]
        ),
        bestDeal: bestDeal && Odigeo.AB.isPricePerceptionRevamp,
        isPrimeDays: isPrimeSelected && Odigeo.AB.isPrimeDays && isPrimeDays,
        indexTracking: index,
        key,
        hasBoardType,
        isAccommodationPostBooking,
        priceWithoutDiscountSelected,
    });
}

function getRenderResults(model, data) {
    return data.map((result, index) => {
        const renderData = getResultData(model, {result, index});

        if (index === data.length - 1) {
            accommodationResultsTracking(data);
        }
        return renderData;
    });
}

function parseCardData(data, keys) {
    const {accommodationSearchReviews, roomsLeft, providerId, providerHotelId, dedupId} = data.accommodationDeal;
    const priceInfo = getPriceInfo(data);
    const tripAdvisorReview = Odigeo._.find(accommodationSearchReviews, (review) => Odigeo._.isEqual(review.usersRateSource, 'TA'));
    const hasUserRateMessage = tripAdvisorReview ? Odigeo._.parseInt(tripAdvisorReview.usersRatePattern) >= HIGH_SCORE_VALUE : false;
    const preselected = Odigeo.Utils.parseJson(Odigeo.Session.get('preselectedAccommodation'));
    const discountLabel = commonParser.getDiscountLabel(priceInfo.discountPercentage, keys);

    return Odigeo._.extend({}, data, {
        hasRoomSelection: true,
        hasHotelRoomsLeft: commonParser.hasHotelRoomsLeft(roomsLeft),
        roomsLeftTranslation: Odigeo.Utils.pluralizeAll(keys.roomsLeft, roomsLeft),
        tripAdvisorRateMessage: hasUserRateMessage ?
            commonParser.getTripAdvisorRateMessage(tripAdvisorReview.usersRatePattern, keys) : '',
        isAccommodationPostBooking: Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking')),
        hasPreselected: preselected && preselected.providerId && preselected.providerHotelId && preselected.dedupId,
        isPreselected: preselected && preselected.providerId == providerId &&
            preselected.providerHotelId == providerHotelId && preselected.dedupId == dedupId,
        discountLabel,
        tripAdvisorReview,
        hasUserRateMessage,
        priceInfo,
    });
}

function accommodationResultsTracking(data) {
    const action = 'results_list_hotels';
    const label = commonParser.getTrackingLabelLoadedResults(data);

    trackingUtils.trackEvent(action, label);
}

module.exports = {
    getResultData,
    getSelectedSortingText,
    getDiscountTrackingLabel,
    getHighlightedType,
    calculateNights,
    getRenderResults,
    parseCardData,
};
